module.exports = __webpack_public_path__ + "img/twitch.653b2cf7.svg";